import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calcTime'
})
export class CalcTimePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}
